import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CountersCard from '../../../../ui/CountersCard';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {
  counterBuildingsQuery,
  counterRoomsQuery,
  counterResourcesQuery,
  counterTypesQuery,
} from "./reducer";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Материально-технические ресурсы",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const ManageOOPResourcesMatTechIndex = ({
                                          history,
                                          counterBuildings,
                                          counterRooms,
                                          counterResources,
                                          counterTypes,
                                          counterBuildingsQuery,
                                          counterRoomsQuery,
                                          counterResourcesQuery,
                                          counterTypesQuery
                                        }) => {

  const classes = useStyles();

  const handleClick = (link) => {
    history.push(link);
  };

  useEffect(() => {
    counterBuildingsQuery();
  }, [counterBuildingsQuery]);

  useEffect(() => {
    counterRoomsQuery();
  }, [counterRoomsQuery]);

  useEffect(() => {
    counterResourcesQuery();
  }, [counterResourcesQuery]);

  useEffect(() => {
    counterTypesQuery();
  }, [counterTypesQuery]);

  return (
    <div>
      <Breadcrumbs items={items}/>
      <div className={classes.root}>
        <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
          {counterBuildings && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterBuildings}
              onClick={handleClick}
              goTo={'/work/app/facilities'}
            />
          </Grid>}
          {counterRooms && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterRooms}
              onClick={handleClick}
              goTo={'/work/app/rooms'}
            />
          </Grid>}
          {counterResources && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterResources}
              onClick={handleClick}
              goTo={'/work/app/resources'}
            />
          </Grid>}
          {counterTypes && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterTypes}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/mattech/nomenclature'}
            />
          </Grid>}
        </Grid>
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  counterBuildings: state.manageOOPResourcesMatTechIndex.counterBuildings,
  counterRooms: state.manageOOPResourcesMatTechIndex.counterRooms,
  counterResources: state.manageOOPResourcesMatTechIndex.counterResources,
  counterTypes: state.manageOOPResourcesMatTechIndex.counterTypes
});


const mapDispatchToProps = dispatch => ({
  counterBuildingsQuery: () => dispatch(counterBuildingsQuery()),
  counterRoomsQuery: () => dispatch(counterRoomsQuery()),
  counterResourcesQuery: () => dispatch(counterResourcesQuery()),
  counterTypesQuery: () => dispatch(counterTypesQuery()),
});


export default  connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageOOPResourcesMatTechIndex));
